import * as React from "react";
import styled, { css } from "styled-components";
import { mediaMax } from "@customer-tools-web/component-ui";
import { space } from "./common";

const Form = styled.form`
  font-size: ${(props) => props?.theme?.fontSize?.body};
  color: ${(props) => props.theme.textColor} input {
    font-size: inhert;
  }
`;

/* stylelint-disable property-no-vendor-prefix */
const Input = styled.input`
  && {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid ${(props) => props.theme.inputBorder};
    border-radius: 3px;
    font-size: ${(props) => props?.theme?.fontSize?.body};
    &[disabled] {
      border-color: ${(props) => props.theme.inputDisabledBorder};
      color: ${(props) => props.theme.inputDisabledColor};
      background-color: ${(props) => props.theme.inputDisabledBg};
    }
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  &[type="number"] {
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
  }
  &&:hover {
    border-color: #d9d9d9;
  }
`;
/* stylelint-enable */

const FormItem = styled.div`
  margin-top: ${1.5 * space}px;
  margin-bottom: ${1.5 * space}px;
  label {
    display: block;
    font-weight: 400;
    font-size: inherit;
  }
`;

const FormItemDescription = styled.div`
  display: block;
  font-weight: 400;
  font-size: ${(props) => props?.theme?.fontSize?.caption};
  color: ${(props) => props.theme.textDeepGray};
  margin-bottom: 5px;
`;

export interface TypeItem {
  layout?: string;
}

const FormItemGroup = styled.div<TypeItem>`
  ${(props) =>
    props.layout === "horizontal" &&
    css`
      display: flex;
      margin-left: -${space / 2}px;
      margin-right: -${space / 2}px;
      > div {
        flex: 1;
        margin: 0 ${space / 2}px;
      }
    `}
`;

const Fieldset = styled.fieldset<{ needMargin?: boolean }>`
  & > div > .ant-row:last-child {
    margin-bottom: 0;
  }
  padding-left: 0;
  padding-right: 0;
  ${({ needMargin }) =>
    needMargin &&
    css`
      margin-bottom: 24px;
    `}
`;

const FormTitle = styled.h1<{ version?: number }>`
  ${(props) =>
    props?.version === 2
      ? `
      margin: 0 0 32px;
      font-size: ${props?.theme?.fontSize?.display2};
      font-weight: 600;
      color: ${props?.theme?.textColor};
      line-height: 40px;
    `
      : `
      margin: 0 0 24px;
      font-size: ${props?.theme?.fontSize?.title1};
      font-weight: bold;
      line-height: normal;
    `}

  ${(props) => mediaMax.md`
    font-size: ${props?.theme?.fontSize?.title1};
  `}
`;
const FormDescription = styled.p`
  line-height: 18px;
  font-size: ${(props) => props?.theme?.fontSize?.caption};
  font-weight: 400;
  color: ${(props) => props.theme.textDeepGray};
`;

const SubLabel = styled.div`
  line-height: 18px;
  font-size: ${(props) => props?.theme?.fontSize?.caption};
  color: ${(props) => props.theme.textDeepGray};
  margin-bottom: 4px;
`;

const Legend = styled.legend`
  font-size: ${(props) => props?.theme?.fontSize?.title3};
  font-weight: 600;
  line-height: 1.33;
  color: ${(props) => props.theme.textColor};
`;

const FormSection: React.FC<{
  id?: string;
  title?: React.ReactNode;
  className?: string;
  needMargin?: boolean;
}> = (props) => (
  <Fieldset
    data-test={props.title}
    id={props.id}
    className={props.className}
    needMargin={props.needMargin}
  >
    {props.title && <Legend>{props.title}</Legend>}
    <div>{props.children}</div>
  </Fieldset>
);

export {
  Form,
  Input,
  FormItem,
  FormItemDescription,
  SubLabel,
  FormSection,
  FormItemGroup,
  FormTitle,
  FormDescription,
  Legend,
};
